import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// @material-ui/core components
import { withStyles } from "@mui/styles";
import { Button, Card, CardBody, GridContainer, GridItem } from "~/shared/components/MuiComponents.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import imgSpearmint from "~assets/images/flavors/spearmint-flavor.png";
import imgTangerine from "~assets/images/flavors/tangerine-flavor.png";
import imgFruitPunch from "~assets/images/flavors/tropical-fruit-medley-flavor.png";

import {
  getOrderItemSubcategory,
  getVisitID,
  getVisitUSState,
  setOrderItemSubcategory,
} from "~/visits/utils/visitCookies";

import {
  COLOR_KICK_BLUE,
  FRUIT_PUNCH_FLAVOR,
  SPEARMINT_FLAVOR,
  TANGERINE_FLAVOR,
} from "~/shared/sharedConstants.js";

import { supportedUSStatesForCompoundedMeds } from "~/shared/utils/sharedUtils";

import { kickBlue } from "~/shared/styles/baseStyles";
import usePendingEditTimeout from "~/visits/utils/usePendingEditTimeout.js";

const flavors = [
  {
    name: "Tangerine Citrus Burst",
    image: imgTangerine,
    flavorConst: TANGERINE_FLAVOR,
    longDescription:
      "Citrus confidence - The bright, juicy essence of perfectly ripened tangerine in a rapid-dissolve tablet. ",
    priceDiff: 10,
  },
  {
    name: "Tropical Fruit Medley",
    image: imgFruitPunch,
    longDescription:
      "Beachy, fruit punch-infused flavor in a fast-acting lozenge. Meds without the wince - just refreshing tropical goodness",
    flavorConst: FRUIT_PUNCH_FLAVOR,
    priceDiff: 10,
  },
  {
    name: "Spearmint Chill",
    image: imgSpearmint,
    longDescription:
      "Iceberg calm in a refreshing spearmint quick-dissolve lozenge. Stay minty cool in the hottest moments.",
    flavorConst: SPEARMINT_FLAVOR,
    priceDiff: 10,
  },
];

const ChooseFlavor = ({ classes, history, match }) => {
  const consultationType = match.params.consultationType;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const checkoutSessionID = queryParams.get("checkoutSessionID");
  if (!checkoutSessionID) {
    window.location.href = "/me/portal";
  }

  usePendingEditTimeout(checkoutSessionID);

  const [selectedFlavor, setSelectedFlavor] = useState(
    getOrderItemSubcategory(consultationType, checkoutSessionID) || null,
  );
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
      return;
    }

    const visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);

    if (!supportedUSStatesForCompoundedMeds.includes(getVisitUSState())) {
      history.replace(
        `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`,
      );
    }

    return () => clearInterval(visitIDCheckPoller);
  }, []);

  const handleSelection = (selectedFlavor) => {
    let modifiedProduct = selectedFlavor;

    setSelectedFlavor(modifiedProduct);
    setShowError(false);
  };

  const nextQuestion = () => {
    if (selectedFlavor === null) {
      setShowError(true);
      return;
    }

    // Save the selected flavor
    setOrderItemSubcategory(
      consultationType,
      selectedFlavor,
      checkoutSessionID,
    );

    // Redirect to payment
    history.push(
      `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`,
    );

    window.scrollTo(0, 0);
  };

  const isSelected = (product) => {
    return selectedFlavor === product;
  };

  return (
    <div
      className={classes.container}
      style={{ backgroundColor: COLOR_KICK_BLUE }}
    >
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={6}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            Choose Your Flavor
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
            }}
          >
            Our special compounded beta-blockers come in three delicious flavors
            that work up to 5x faster for those big unexpected moments. No need
            to plan ahead when taking your meds.
            <br />
            <br />
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}></GridItem>
        <GridItem xs={12} sm={10} md={6}>
          <Card
            className={classes.cardConsultation}
            style={{ paddingTop: "20px", paddingBottom: "20px" }}
          >
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              {flavors.map((flavor, idx) => {
                return (
                  <div key={flavor.flavorConst}>
                    <div
                      className={classes.selectFlavoredProductWrapper}
                      style={{
                        overflow: "hidden",
                        backgroundColor: isSelected(flavor.flavorConst)
                          ? "#fff7e5"
                          : "",
                      }}
                      onClick={() => handleSelection(flavor.flavorConst)}
                    >
                      <img
                        src={flavor.image}
                        style={{
                          position: "relative",
                          width: "200px",
                          height: "200px",
                          // border: "2px solid gray",
                        }}
                        alt={`${flavor.name} Flavor`}
                      />
                      <div className={classes.selectFlavorImageTitleWrapper}>
                        <h4
                          className={classes.selectFlavorImageTitle}
                          style={{
                            color: kickBlue,
                            fontWeight: "bold",
                          }}
                        >
                          {flavor.name}
                        </h4>
                        <p
                          style={{
                            marginTop: "4px",
                            marginBottom: "8px",
                            fontSize: "16px",
                          }}
                        >
                          {flavor.longDescription}
                        </p>
                        {/* {!!priceDiff && (
                          <p
                            style={{ marginBottom: "0" }}
                          >{`+$${priceDiff}`}</p>
                        )} */}
                      </div>
                    </div>
                    {idx !== flavors.length - 1 && (
                      <div
                        style={{
                          height: "1px",
                          margin: "0 25%",
                          backgroundColor: "#aaa",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </CardBody>
          </Card>
          <div style={{ color: "red", margin: "20px auto 6px auto" }}>
            <p style={{ textAlign: "center" }}>
              {showError ? "Please select a flavor above" : ""}
            </p>
          </div>
          <Button
            onClick={() => {
              nextQuestion();
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "16px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(ChooseFlavor);
